import styled from 'styled-components';

export const Button = styled.button`
  outline: none;
  text-align: center;
  padding: 8px 16px;
  border-radius: 4px;
  font-family: 'Lato';
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  border: none;
  flex: 1;
  gap: 8px;
  align-items: center;
  flex-direction: row;
  display: flex;
  justify-content: center;
  position: relative;

  &.type1 {
    background: #008cff;
    color: #fff;
  }

  &.type2 {
    background: #fff;
    color: #008cff;
    border: 1px solid #008cff;
  }

  &.type3 {
    background: linear-gradient(94deg, #53B2FE 0%, #065AF3 100%);
    color: #fff;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 900;
    line-height: 20px;
  }
`;

export const ArrowIcon = styled.img`
  width: 18px;
  height: 14px;
`;
